/** sessionStorage: EUR-only browsing after a second-home landing page. */
export const SECOND_HOME_FUNNEL_KEY = 'cv_second_home_eur_funnel';

export function isSecondHomeFunnelActive() {
    if (typeof sessionStorage === 'undefined') {
        return false;
    }
    try {
        return sessionStorage.getItem(SECOND_HOME_FUNNEL_KEY) === '1';
    } catch {
        return false;
    }
}

export function activateSecondHomeFunnel() {
    if (typeof sessionStorage === 'undefined') {
        return;
    }
    try {
        sessionStorage.setItem(SECOND_HOME_FUNNEL_KEY, '1');
    } catch {
        // ignore quota / private mode
    }
    if (typeof document !== 'undefined' && document.documentElement) {
        document.documentElement.classList.add('cv-second-home-funnel');
    }
}

export function clearSecondHomeFunnel() {
    if (typeof sessionStorage !== 'undefined') {
        try {
            sessionStorage.removeItem(SECOND_HOME_FUNNEL_KEY);
        } catch {
            // ignore
        }
    }
    if (typeof document !== 'undefined' && document.documentElement) {
        document.documentElement.classList.remove('cv-second-home-funnel');
    }
}
